import { EmailSettingsFormPage } from "~/pages/EmailSettingsFormPage";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/email-settings/templates/create")({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();

  useBreadCrumbs([
    { title: "Email Settings", link: `/${params.datasetSlug}/settings/email-settings` },
    { title: "Create", link: `/${params.datasetSlug}/settings/email-settings/create` },
  ]);
  return <EmailSettingsFormPage />;
}
